// extracted by mini-css-extract-plugin
module.exports =  {"labelText":"labelText__Cl7f6","customizedLegend":"customizedLegend__IIKdw","categoryLegendItem":"categoryLegendItem__Llx7o"};